import { createActions, createAction } from 'redux-actions';
import { request } from '../../services';


const {
  savedFiltersListRequest,
  savedFiltersListSuccess,
  savedFiltersListFailure,
} = createActions({
  SAVED_FILTERS_LIST_SUCCESS: [
    json => json.saved_filters,
    json => json.meta,
  ],
},
  'SAVED_FILTERS_LIST_REQUEST',
  'SAVED_FILTERS_LIST_FAILURE',
);

export const updateSavedFilterPosition = createAction(
  'UPDATE_SAVED_FILTER_POSITION',
  (oldPosition, newPosition) => ({
    oldPosition,
    newPosition,
  }),
);

export const requestSavedFilters = () => (dispatch) => {
  dispatch(savedFiltersListRequest());
  return request('saved_filters')
  .then(({
    json,
  }) => {
    const mapped = json;
    mapped.saved_filters = json.saved_filters.map(e => ({
      ...e,
      type: 'saved',
    }));
    return mapped;
  })
  .then(json => dispatch(savedFiltersListSuccess(json)))
  .catch(error => dispatch(savedFiltersListFailure(error)));
};

const {
  savedFilterCreateRequest,
  savedFilterCreateSuccess,
  savedFilterCreateFailure,
} = createActions({
  SAVED_FILTER_CREATE_SUCCESS: json => json.saved_filter,
},
  'SAVED_FILTER_CREATE_REQUEST',
  'SAVED_FILTER_CREATE_FAILURE',
);

export const createSavedFilter = savedFilter => (dispatch) => {
  dispatch(savedFilterCreateRequest());

  return request('saved_filters/', {
    method: 'POST',
    body: {
      saved_filter: savedFilter,
    },
  })
  .then(({
    json,
  }) => dispatch(savedFilterCreateSuccess(json)))
  .catch(error => dispatch(savedFilterCreateFailure(error)));
};

const {
  savedFilterUpdateRequest,
  savedFilterUpdateSuccess,
  savedFilterUpdateFailure,
} = createActions({
  SAVED_FILTER_UPDATE_SUCCESS: json => json.saved_filter,
}, 'SAVED_FILTER_UPDATE_REQUEST', 'SAVED_FILTER_UPDATE_FAILURE');

export const updateSavedFilter = (savedFilter, savedFilterId) => (dispatch) => {
  dispatch(savedFilterUpdateRequest());
  return request(`saved_filters/${savedFilterId}`, {
    method: 'PUT',
    body: {
      saved_filter: savedFilter,
    },
  })
  .then(({
    json,
  }) => dispatch(savedFilterUpdateSuccess(json)))
  .catch(error => dispatch(savedFilterUpdateFailure(error)));
};

const {
  savedFilterDeleteRequest,
  savedFilterDeleteSuccess,
  savedFilterDeleteFailure,
} = createActions({
  SAVED_FILTER_DELETE_SUCCESS: savedFilterId => ({
    savedFilterId,
  }),
}, 'SAVED_FILTER_DELETE_REQUEST', 'SAVED_FILTER_DELETE_FAILURE');


export const deleteSavedFilter = savedFilterId => (dispatch) => {
  dispatch(savedFilterDeleteRequest());
  return request(`saved_filters/${savedFilterId}`, {
    method: 'DELETE',
  })
  .then(() => dispatch(savedFilterDeleteSuccess(savedFilterId)))
  .catch(error => dispatch(savedFilterDeleteFailure(error)));
};



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/saved_filters.js